module.exports = "/assets/f410776a43d0c7bb3a9506a84b30a7ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/P8.png
// module id = 1707
// module chunks = 0